module.exports = __webpack_public_path__ + "static/img/13.e91bddf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/13.png
// module id = 0O91
// module chunks = 0